<template>
  <el-dialog
    :title="'企业管理：' + DialogFormData.id"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="1100px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="l('企业类型')" prop="business_tag_id">
            <el-select
              v-model="DialogFormData.business_tag_id"
              :placeholder="l('请选择') + l('企业类型')"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item of $store.state.basicInfo.tagList.business_1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="企业名称" prop="name">
            <el-input
              v-model="DialogFormData.name"
              placeholder="请输入企业名称"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <ResourceUpLoad
            label="营业执照"
            prop="business_license"
            usage="auth"
            :initResourceUrl.sync="DialogFormData.business_license"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button
        v-if="
          Type == 'View' && $store.getters.checkPermission('admin_tenant.edit')
        "
        type="warning"
        @click="Type = 'Edit'"
        >{{ l("修 改") }}</el-button
      >
      <el-button v-if="Type == 'Edit'" type="primary" @click="submitForm">{{
        l("保 存")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditTenant",
  mixins: [dialogMixin],
  data() {
    return {
      //基本信息
      DialogFormData: {
        id: "",
        name: "",
        business_tag_id: "",
        business_license: "",
      },
      dialogRules: {
        name: [
          {
            required: true,
            message: this.l("请输入") + this.l("内容"),
            trigger: "blur",
          },
        ],
        business_tag_id: [
          {
            required: true,
            message: this.l("请选择") + this.l("企业类型"),
            trigger: "blur",
          },
        ],
        business_license: [
          {
            required: true,
            message: this.l("请上传") + this.l("照片"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        this.getTenantInfo(resolve, reject);
      });
    },
    AfterShow() {},
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.axios
          .put(
            `/api/admin_tenant/${this.DialogFormData.id}/edit_auth/`,
            this.DialogFormData
          )
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    getTenantInfo(resolve, reject) {
      this.axios
        .get(`/api/admin_tenant/${this.DialogFormData.id}/`)
        .then((response) => {
          this.DialogFormData = response;
          resolve && resolve();
        })
        .catch(() => {
          reject && reject();
        });
    },
  },
};
</script>


<style scoped lang="scss">
</style>



